import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'lyceo-walkthrough-card',
  imports: [],
  templateUrl: './walkthrough-card.component.html',
  styleUrls: ['./walkthrough-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'lyceo-walkthrough-card',
  },
})
export class WalkthroughCardComponent {}
